export default __webpack_public_path__ + "static/media/lk_3.aad3814a.jpg";